BaseStep = App.loadClass("grower::viewmodels/fields/add/steps/BaseStep")

class exports.SaveField extends BaseStep

    beforeSet: () ->
        @saveStatus     = ko.observable()
        @saveErrors     = ko.observableArray()
        @zoneStatus     = ko.observable("")
        @canGoBack      = ko.observable false


    afterSet: () ->
        @parent.currentField().hideGeometry()
        @saveStatus "Saving..."
        @parent.currentField().save(@_saveComplete)


    _saveComplete: (result) =>
        @saveErrors []
        if not result?.status?
            @saveStatus result
            return

        @_handleResult result, @saveStatus, (result) =>
            if @parent.currentField().id?
                @saveStatus "Field updated successfully"
            else
                @parent.currentField().id = result.data.id
                @saveStatus "Field Saved successfully"

            #if @parent.currentField().irrigationData?().length > 0
            if @parent.anyManagementZonesSelected()
                @zoneStatus "Saving your permanent zones..."
                # Set the zones to belong to the current field
                @parent.zoneManager.setFieldsId(@parent.currentField().id)
                # Save all the zones
                @parent.zoneManager.save( @_saveZonesComplete)
            else
                @continue()



    _handleResult: (result, statusvar, success, error) =>
        @saveErrors []
        if not result?.status?
            statusvar result
            @canGoBack true
            return

        if result.status.type is "success"
            @canGoBack false
            success(result)

        else
            @canGoBack true
            statusvar result.status.msg
            if result.data?.errors?
                @saveErrors result.data.errors
            if $.isFunction(error)
                error()



    _saveZonesComplete: (result) =>
        count   = 0
        success = 0

        status = ko.observable("")

        for i in result
            count++
            oldstat = status()

            @_handleResult i.result, status, (r) =>
                success++
                name = i.zone_type
                status "<br />" + name + " zones saved successfully"

            status(oldstat + status())


        @zoneStatus status()

        if success is count
            @continue()
        else
            @canGoBack true

        ##for i in result
        #    if ok

        #@_handleResult result, @zoneStatus, (result) =>
        #    if @parent.currentField().irrigation_id?
        #        @zoneStatus "Permanent zones updated successfully"
        #    else
        #        @parent.currentField().irrigation_id = result.data.id
        #        @zoneStatus "Permanent zones saved successfully"

        #    @continue()


    continue: () ->
        @canGoBack false
        dlg = @parent.handler.createSubHandler "grower::handlers/fields/dialogs/FieldDetailsDialog"
        if dlg
            dlg.modalOptions = { backdrop: 'static' }
            dlg.loadLayoutPostOptions = { id: @parent.currentField().id }
            dlg.refreshNavHandler = false

            dlg.afterHidden = () =>
                dlg.destroy()
                @parent.changeStep "wantAddMoreFields"

            dlg.init()
